var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _mask7, _path11, _path12, _mask8, _path13, _path14, _mask9, _path15, _path16, _path17, _path18, _path19, _ellipse, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 173,
    viewBox: "0 0 172 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 0.926751,
    y: 86.5176,
    width: 87,
    height: 74,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.926751,
    y: 86.5176,
    width: 87,
    height: 74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.893 159.515C30.7755 153.152 22.1033 144.738 15.4357 134.815C8.76812 124.893 4.25317 113.683 2.18199 101.907L86.4073 87.0784L40.893 159.515Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.893 159.515C30.7755 153.152 22.1033 144.738 15.4357 134.815C8.76812 124.893 4.25317 113.683 2.18199 101.907L86.4073 87.0784L40.893 159.515Z",
    fill: "#29C18C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.893 159.515C30.7755 153.152 22.1033 144.738 15.4357 134.815C8.76812 124.893 4.25317 113.683 2.18199 101.907L86.4073 87.0784L40.893 159.515Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-1-outside-1_12382_25998)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 39.9268,
    y: 86.5176,
    width: 95,
    height: 87,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 39.9268,
    y: 86.5176,
    width: 95,
    height: 87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.945 158.202C120.229 167.379 104.153 172.389 87.6553 172.63C71.1573 172.871 54.9419 168.332 40.9644 159.56L86.4073 87.0784L133.945 158.202Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.945 158.202C120.229 167.379 104.153 172.389 87.6553 172.63C71.1573 172.871 54.9419 168.332 40.9644 159.56L86.4073 87.0784L133.945 158.202Z",
    fill: "#F0EADB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.945 158.202C120.229 167.379 104.153 172.389 87.6553 172.63C71.1573 172.871 54.9419 168.332 40.9644 159.56L86.4073 87.0784L133.945 158.202Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-2-outside-2_12382_25998)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 84.4629,
    y: 86.5176,
    width: 84,
    height: 72,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 84.4629,
    y: 86.5176,
    width: 84,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.801 157.987C149.901 147.111 161.819 131.075 167.595 112.519L85.9434 87.0784L133.801 157.987Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.801 157.987C149.901 147.111 161.819 131.075 167.595 112.519L85.9434 87.0784L133.801 157.987Z",
    fill: "#E9ADCA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.801 157.987C149.901 147.111 161.819 131.075 167.595 112.519L85.9434 87.0784L133.801 157.987Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-3-outside-3_12382_25998)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-4_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 84.4629,
    y: 17.5176,
    width: 88,
    height: 96,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 84.4629,
    y: 17.5176,
    width: 88,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.528 112.734C172.83 95.8571 172.773 77.7503 167.364 60.9068C161.955 44.0633 151.46 29.3114 137.325 18.6821L85.9434 87.0784L167.528 112.734Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.528 112.734C172.83 95.8571 172.773 77.7503 167.364 60.9068C161.955 44.0633 151.46 29.3114 137.325 18.6821L85.9434 87.0784L167.528 112.734Z",
    fill: "#CCA3CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.528 112.734C172.83 95.8571 172.773 77.7503 167.364 60.9068C161.955 44.0633 151.46 29.3114 137.325 18.6821L85.9434 87.0784L167.528 112.734Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-4-outside-4_12382_25998)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-5_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 4.46289,
    y: 16.5176,
    width: 83,
    height: 72,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4.46289,
    y: 16.5176,
    width: 83,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7478 17.0919C21.9057 27.535 10.7683 42.4304 4.94604 59.6242L85.9434 87.0784L36.7478 17.0919Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7478 17.0919C21.9057 27.535 10.7683 42.4304 4.94604 59.6242L85.9434 87.0784L36.7478 17.0919Z",
    fill: "#F5CC3B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7478 17.0919C21.9057 27.535 10.7683 42.4304 4.94604 59.6242L85.9434 87.0784L36.7478 17.0919Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-5-outside-5_12382_25998)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-6_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 36.4629,
    y: 4.51757,
    width: 50,
    height: 83,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 36.4629,
    y: 4.51757,
    width: 50,
    height: 83
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.959 16.9438C44.3786 11.7567 52.5743 7.78092 61.24 5.16499L85.9434 87.0784L36.959 16.9438Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.959 16.9438C44.3786 11.7567 52.5743 7.78092 61.24 5.16499L85.9434 87.0784L36.959 16.9438Z",
    fill: "#BBE6E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.959 16.9438C44.3786 11.7567 52.5743 7.78092 61.24 5.16499L85.9434 87.0784L36.959 16.9438Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-6-outside-6_12382_25998)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-7_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 60.4629,
    y: 0.517573,
    width: 27,
    height: 87,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 60.4629,
    y: 0.517573,
    width: 27,
    height: 87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4541 5.10068C69.5277 2.6865 77.9136 1.4794 86.34 1.51849L85.9434 87.0784L61.4541 5.10068Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4541 5.10068C69.5277 2.6865 77.9136 1.4794 86.34 1.51849L85.9434 87.0784L61.4541 5.10068Z",
    fill: "#99439D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4541 5.10068C69.5277 2.6865 77.9136 1.4794 86.34 1.51849L85.9434 87.0784L61.4541 5.10068Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-7-outside-7_12382_25998)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-8_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 81.307,
    y: -0.736984,
    width: 59.2238,
    height: 95.3316,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 81.307,
    y: -0.736984,
    width: 59.2238,
    height: 95.3316
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.616 1.61742C104.89 2.12774 122.591 8.10595 137.435 18.7804L84.0666 93.0701L86.616 1.61742Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.616 1.61742C104.89 2.12774 122.591 8.10595 137.435 18.7804L84.0666 93.0701L86.616 1.61742Z",
    fill: "#87A1FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.616 1.61742C104.89 2.12774 122.591 8.10595 137.435 18.7804L84.0666 93.0701L86.616 1.61742Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-8-outside-8_12382_25998)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-9_12382_25998",
    maskUnits: "userSpaceOnUse",
    x: 0.279292,
    y: 58.2031,
    width: 93,
    height: 45,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.279292,
    y: 58.2031,
    width: 93,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32174 58.7797C0.7953 72.8203 -0.279743 87.7461 2.18785 102.291L92.5871 86.9397L5.32174 58.7797Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32174 58.7797C0.7953 72.8203 -0.279743 87.7461 2.18785 102.291L92.5871 86.9397L5.32174 58.7797Z",
    fill: "#E25297"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32174 58.7797C0.7953 72.8203 -0.279743 87.7461 2.18785 102.291L92.5871 86.9397L5.32174 58.7797Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-9-outside-9_12382_25998)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9498 155.042C123.204 155.042 153.404 124.611 153.404 87.0731C153.404 49.5351 123.204 19.1045 85.9498 19.1045C48.6962 19.1045 18.4961 49.5351 18.4961 87.0731C18.4961 124.611 48.6962 155.042 85.9498 155.042Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9557 152.02C121.554 152.02 150.412 122.942 150.412 87.0717C150.412 51.2016 121.554 22.123 85.9557 22.123C50.3573 22.123 21.499 51.2016 21.499 87.0717C21.499 122.942 50.3573 152.02 85.9557 152.02Z",
    fill: "#F6F7F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.912 87.0717C148.912 122.124 120.715 150.52 85.9557 150.52C51.1964 150.52 22.999 122.124 22.999 87.0717C22.999 52.0192 51.1964 23.623 85.9557 23.623C120.715 23.623 148.912 52.0192 148.912 87.0717Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.7973,
    cy: 86.9428,
    rx: 60.6918,
    ry: 60.6918,
    fill: "#E1E1E1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2962 83.0855V71.9744C75.2962 68.2707 77.5184 60.8633 86.4073 60.8633C95.2962 60.8633 97.5184 68.2707 97.5184 71.9744V83.0855M75.2962 83.0855H66.9629V110.863H105.852V83.0855H97.5184M75.2962 83.0855H97.5184",
    stroke: "#123051",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8189 154.033C122.856 154.033 152.881 123.994 152.881 86.9391C152.881 49.884 122.856 19.8447 85.8189 19.8447C48.7814 19.8447 18.7568 49.884 18.7568 86.9391C18.7568 123.994 48.7814 154.033 85.8189 154.033Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelNotFound);
export default __webpack_public_path__ + "static/media/wheel-not-found.1f84d96b4687ab6ba5f7cedd6ed7dbe1.svg";
export { ForwardRef as ReactComponent };